import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenMessageUser } from '../models/open-message/open-message-user.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OpenMessageUserService extends RequestService<OpenMessageUser> {
  static PATH = '/open/message/user';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OpenMessageUserService.PATH, globalService.debugUrl);
  }
}
